<template>
  <section class="live-status btn-group btn-group-sm">
    <div :class="[mode === 'PROD' ? prodClasses : testClasses]">
      <span class="badge badge-pill badge-light mb-0">
        {{ mode }}
      </span>
    </div>

    <div :class="[mode === 'PROD' ? prodClasses : testClasses]">
      <span class="badge badge-pill badge-light mb-0">
        {{ room.name }}
      </span>
    </div>
  </section>
</template>

<script>
import {
  mapState,
  mapGetters
} from 'vuex'
// import l from '@/vendor/logger'
import now from '@/mixins/now'

export default {
  name: 'LiveStatus',

  mixins: [now],

  data () {
    return {
      testClasses: 'btn btn-secondary',
      prodClasses: 'btn bg-danger progress-bar progress-bar-striped progress-bar-animated'
    }
  },

  computed: {
    ...mapState('room', [
      'room'
    ]),
    ...mapState([
      'mode'
    ]),
    ...mapGetters('room', [
      'isStudio'
    ])
  }
}
</script>

<style scoped>
</style>
